import { Env, readFromEnv } from '@cinch-nx/environments'
import { AiSearchApiResponse, AiSearchApiInput } from './types'
import axios, { AxiosResponse } from 'axios'

const AI_SEARCH_API_URL =
  readFromEnv(Env.AiSearchServiceUrl) + '/natural-language-search'

/**
 * Queries the AI search API with a natural language search string.
 *
 * @param query - The search query string to send to the AI search API
 * @returns A promise that resolves to an AiSearchApiResponse object if successful, or undefined if an error occurs
 * @throws Does not throw; errors are caught and logged to console
 *
 * @example
 * const result = await queryAiSearch('black suv with 7 seats');
 */
export async function queryAiSearch(
  query: string,
): Promise<AiSearchApiResponse | undefined> {
  try {
    const response = await axios.post<
      AiSearchApiResponse,
      AxiosResponse<AiSearchApiResponse>,
      AiSearchApiInput
    >(AI_SEARCH_API_URL, {
      query: query,
    })
    return response.data
  } catch (error) {
    console.error('Error in searchWithAi:', error)
    return undefined
  }
}
